"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextAvailableDay = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var isDateBlackout_1 = require("./isDateBlackout");
dayjs_1.default.extend(utc_1.default);
var getNextAvailableDay = function (collectionDateConfig, day) {
    /**
     * Get timeslots.
     */
    var _a = collectionDateConfig || {}, blackoutDays = _a.blackoutDays, leadTime = _a.leadTime, blackoutDates = _a.blackoutDates, cutoffTime = _a.cutoffTime;
    var now = day || dayjs_1.default.utc();
    var leadDays = leadTime ? Math.floor(leadTime / 24) : 0;
    var daysToAdd = leadDays;
    var time = cutoffTime === null || cutoffTime === void 0 ? void 0 : cutoffTime.split(":");
    /**
     * Add day if cutoff time has passed.
     */
    if (time) {
        var cutoff = dayjs_1.default
            .utc(now)
            .set("hour", Number(time[0]))
            .set("minute", Number(time[1]));
        var cutOffPassed = now > cutoff;
        if (cutOffPassed) {
            daysToAdd += 1;
        }
    }
    /**
     * Traverse through added days for blackouts.
     */
    while (daysToAdd !== 0) {
        now = now.add(1, "day");
        /**
         * If next day happens to be a blackout, keep adding days
         */
        if (!isDateBlackout_1.isDateBlackout(now, blackoutDates || [], blackoutDays || [])) {
            daysToAdd -= 1;
        }
    }
    /**
     * Final lead time hours check.
     */
    if (leadTime && leadTime % 24 !== 0) {
        now = now.add(leadTime - leadDays * 24, "hour");
        var count = 0;
        var loop = true;
        // If knocks on to next day, traverse next days for blackouts
        while (loop) {
            count += 1;
            if (isDateBlackout_1.isDateBlackout(now, blackoutDates || [], blackoutDays || [])) {
                now = now.add(24, "hour");
            }
            else {
                loop = false;
            }
            // Prevent endless loop
            if (count > 100) {
                loop = false;
            }
        }
    }
    // Assign new startDate.
    if (time) {
        return now.set("hour", Number(time[0])).set("minute", Number(time[1]));
    }
    return now.endOf("day");
};
exports.getNextAvailableDay = getNextAvailableDay;
